import { Discount } from '../../api/discount/discount.model.js';
import { Child } from '../../api/child/child.model.js';
import { Course } from '../../api/course/course.model.js';
import { AppliedDiscountSubscription } from '../../api/discount/lib/discount.interfaces.js';
import { Workshop } from '../../api/workshop/workshop.model';

export interface ShoppingCart {
  registrations: ShoppingCartRegistration[];
}

export interface ShoppingCartExtraInfoStore
  extends Record<string, ShoppingCartExtraInformation> {}

export interface ShoppingCartItemRegistration {
  child: Child;
  appliedDiscount?: Discount | AppliedDiscountSubscription;
  error?: string;
}

export interface ShoppingCartExtraInformation {
  infoForCamp: string;
  infoForAdmin: string;
}

export interface ShoppingCartCourseRegistration
  extends ShoppingCartItemRegistration {
  course: Course;
  workshop?: never;
}

export interface ShoppingCartWorkshopRegistration
  extends ShoppingCartItemRegistration {
  course?: never;
  workshop: Workshop;
}

export type ShoppingCartRegistration =
  | ShoppingCartCourseRegistration
  | ShoppingCartWorkshopRegistration;

export function getEmptyCart(): ShoppingCart {
  return { registrations: [] };
}
